import { useNavigate } from 'react-router-dom'

import { UserAvatar } from '@/components/common/UserAvatar'
import type { Report } from '@/types/report.types'
import { formatPLN } from '@/utils/currency'
import { formatDate } from '@/utils/dates'

interface RecentReportItemProps {
  report: Report;
}

export function RecentReportItem({ report: r }: RecentReportItemProps) {
  const driverName = r.driverName || ''
  const vehiclePlate = r.vehiclePlate || ''
  const navigate = useNavigate()

  return (
    <div
      className="px-5 py-2 flex items-center gap-4 cursor-pointer transition-colors hover:bg-zinc-50 dark:hover:bg-zinc-800/50"
      onClick={() => navigate(`/reports/${r.id}`)}
    >
      <UserAvatar name={driverName} className="rounded-xl flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold truncate text-zinc-800 dark:text-zinc-200">
          {r.identifier && <span className="text-zinc-500 mr-1.5">#{r.identifier}</span>}
          {driverName}
        </div>
        <div className="text-xs mt-0.5 text-zinc-400 dark:text-zinc-600">
          {vehiclePlate} · {formatDate(r.dateFrom)} – {formatDate(r.dateTo)}
        </div>
      </div>
      <div className="text-right flex flex-col items-end">
        <div className="text-md font-black">
          {formatPLN(r.totalGrossPLN)} PLN
        </div>
        <div className="text-xs font-medium text-zinc-400 mt-0.5">
          {formatPLN(r.totalGrossEUR)} EUR
        </div>
        <div className="mt-1.5 origin-right">
        </div>
      </div>
    </div>
  )
}
